export default __webpack_public_path__ + "static/media/QuueryLogo.8d421b70.png";